import * as React from 'react';

import './MatchStream.scss'
import { TickerMatchState, TickerMatch } from '../../models';
import { Helmet } from 'react-helmet';
import { StreamSetScore } from './StreamSetScore';
import { BeachTickerMatch } from '../../beach/model';
import { BeachTickerMatchState } from '../../../../shared/beach/ticker';

interface Props {
  match: TickerMatch | BeachTickerMatch
  matchState: TickerMatchState | BeachTickerMatchState
  size?: string
}

const MatchStream = (props: Props) => {

    const {
      match,
      matchState,
      size
    } = props

    return <div className="MatchStream">
      <Helmet>
        <title>{match.teamDescription1} - {match.teamDescription2}</title>
      </Helmet>
      <StreamSetScore matchState={matchState} match={match} size={size} />
    </div>

}

export default MatchStream
